import { LOGIN } from "../../api/constApi";
import { apiInstance } from "./axiosApi";


export const LoginApi = (payload) => {
    return apiInstance.post(LOGIN, payload);
};